/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.213.0-v202610152243-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqApprovalFlowAssignmentsApiClass {
 
   constructor() {}

  /**
   * @summary Approve an item into a step of an approval flow
   * @param {string} flowId - The Seeq ID of the approval flow
  */
  public createApprovalFlowAssignment(
    body: models.ApprovalFlowAssignmentInputV1,
    {
      flowId
    } : {
      flowId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (flowId === null || flowId === undefined) {
      throw new Error("'flowId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/approval-flows/${encodeURIComponent(String(flowId))}/assignments`
      .replace('{flowId}', encodeURIComponent(String(flowId)));
    const urlTemplate = `${baseUrl}/approval-flows/{flowId}/assignments`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ApprovalFlowAssignmentOutputV1>;
  }

  /**
   * @summary Get a single approval flow assignment by id
   * @param {string} flowId - The Seeq ID of the approval flow
   * @param {string} id - The Seeq ID of the approval flow assignment
   * @param {boolean} [includeArchived=false] - Return the assignment even if its flow or step is archived
  */
  public getApprovalFlowAssignment(
    {
      flowId,
      id,
      includeArchived
    } : {
      flowId: string,
      id: string,
      includeArchived?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (flowId === null || flowId === undefined) {
      throw new Error("'flowId' parameter required");
    }

    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/approval-flows/${encodeURIComponent(String(flowId))}/assignments/${encodeURIComponent(String(id))}`
      .replace('{flowId}', encodeURIComponent(String(flowId)))
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/approval-flows/{flowId}/assignments/{id}`;

    const queryParams = {
      ['includeArchived']: includeArchived
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ApprovalFlowAssignmentOutputV1>;
  }

  /**
   * @summary List the assignments in an approval flow
   * @param {string} flowId - The Seeq ID of the approval flow
   * @param {string} [itemId] - Only return assignments for this item
   * @param {string} [stepId] - Only return assignments approved into this step
   * @param {boolean} [includeArchived=false] - Include assignments belonging to an archived flow or step
   * @param {number} [offset=0] - Pagination offset
   * @param {number} [limit=40] - Page size
  */
  public listApprovalFlowAssignments(
    {
      flowId,
      itemId,
      stepId,
      includeArchived,
      offset,
      limit
    } : {
      flowId: string,
      itemId?: string,
      stepId?: string,
      includeArchived?: boolean,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (flowId === null || flowId === undefined) {
      throw new Error("'flowId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/approval-flows/${encodeURIComponent(String(flowId))}/assignments`
      .replace('{flowId}', encodeURIComponent(String(flowId)));
    const urlTemplate = `${baseUrl}/approval-flows/{flowId}/assignments`;

    const queryParams = {
      ['itemId']: itemId,      ['stepId']: stepId,      ['includeArchived']: includeArchived,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ApprovalFlowAssignmentOutputListV1>;
  }

}


export const sqApprovalFlowAssignmentsApi = new sqApprovalFlowAssignmentsApiClass();

export type sqApprovalFlowAssignmentsApiEndpoints = {
  'createApprovalFlowAssignment': {
    method: 'post';
    path: '/approval-flows/${encodeURIComponent(String(flowId))}/assignments';
    response: models.ApprovalFlowAssignmentOutputV1;
  };
  'getApprovalFlowAssignment': {
    method: 'get';
    path: '/approval-flows/${encodeURIComponent(String(flowId))}/assignments/${encodeURIComponent(String(id))}';
    response: models.ApprovalFlowAssignmentOutputV1;
  };
  'listApprovalFlowAssignments': {
    method: 'get';
    path: '/approval-flows/${encodeURIComponent(String(flowId))}/assignments';
    response: models.ApprovalFlowAssignmentOutputListV1;
  };
};

type ApiCreateApprovalFlowAssignmentResponse = models.ApprovalFlowAssignmentOutputV1;
type ApicreateApprovalFlowAssignmentMutationParams = Parameters<typeof sqApprovalFlowAssignmentsApi.createApprovalFlowAssignment> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqApprovalFlowAssignmentsApi.createApprovalFlowAssignment>;

export function useApiCreateApprovalFlowAssignmentMutation(
  options?: Omit<UseMutationOptions<ApiCreateApprovalFlowAssignmentResponse, AxiosError<SeeqErrorData>,
    ApicreateApprovalFlowAssignmentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateApprovalFlowAssignmentResponse, AxiosError<SeeqErrorData>,
  ApicreateApprovalFlowAssignmentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApicreateApprovalFlowAssignmentMutationParams) =>
      sqApprovalFlowAssignmentsApi.createApprovalFlowAssignment(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetApprovalFlowAssignmentResponse = models.ApprovalFlowAssignmentOutputV1;
export function GetApprovalFlowAssignmentQueryKey(
  params: Parameters<typeof sqApprovalFlowAssignmentsApi.getApprovalFlowAssignment>[0],
) {
  return ['sqApprovalFlowAssignmentsApi', 'getApprovalFlowAssignment', params] as const;
}

export function useApiGetApprovalFlowAssignmentQuery(
  params: Parameters<typeof sqApprovalFlowAssignmentsApi.getApprovalFlowAssignment>[0],
  options?: Omit<UseQueryOptions<ApiGetApprovalFlowAssignmentResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetApprovalFlowAssignmentResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetApprovalFlowAssignmentQueryKey(params),
    queryFn: () =>
      sqApprovalFlowAssignmentsApi.getApprovalFlowAssignment(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiListApprovalFlowAssignmentsResponse = models.ApprovalFlowAssignmentOutputListV1;
export function ListApprovalFlowAssignmentsQueryKey(
  params: Parameters<typeof sqApprovalFlowAssignmentsApi.listApprovalFlowAssignments>[0],
) {
  return ['sqApprovalFlowAssignmentsApi', 'listApprovalFlowAssignments', params] as const;
}

export function useApiListApprovalFlowAssignmentsQuery(
  params: Parameters<typeof sqApprovalFlowAssignmentsApi.listApprovalFlowAssignments>[0],
  options?: Omit<UseQueryOptions<ApiListApprovalFlowAssignmentsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiListApprovalFlowAssignmentsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: ListApprovalFlowAssignmentsQueryKey(params),
    queryFn: () =>
      sqApprovalFlowAssignmentsApi.listApprovalFlowAssignments(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
